import { CompanyProfile } from './CompanyProfile';

export enum MapYourShowPortalLoginStatus {
    Success = 'success',
    Error = 'error',
    UserNotLinked = 'user_not_linked',
    EmailMismatch = 'email_mismatch',
}

export type MapYourShowPortalLoginResponse =
    | { status: MapYourShowPortalLoginStatus.Success; exhibitorId: string }
    | { status: MapYourShowPortalLoginStatus.UserNotLinked; email: string; exhibitorId: string }
    | { status: MapYourShowPortalLoginStatus.EmailMismatch; email: string }
    | { status: MapYourShowPortalLoginStatus.Error; message?: string };

export enum MapYourShowCheckProfileStatus {
    Found = 'found',
    NoLinkedProfile = 'no_linked_profile',
    Error = 'error',
}

export type MapYourShowCheckProfileResponse =
    | { status: MapYourShowCheckProfileStatus.Found; profileId: string }
    | {
          status: MapYourShowCheckProfileStatus.NoLinkedProfile;
          availableProfiles: CompanyProfile[];
          exhibitorName: string;
          exactMatch?: string;
      }
    | { status: MapYourShowCheckProfileStatus.Error; message?: string };

export enum MapYourShowRequestStatus {
    Pending = 'pending',
    Approved = 'approved',
    Denied = 'denied',
}

export const MapYourShowRequestOptions = [
    { label: 'Pending', value: MapYourShowRequestStatus.Pending },
    { label: 'Approved', value: MapYourShowRequestStatus.Approved },
    { label: 'Denied', value: MapYourShowRequestStatus.Denied },
];

export type MapYourShowExhibitorData = {
    exhid: string;
    package: string;
    exhname: string;
    sortkey: string;
    alpha: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    email: string;
    phone: string;
    phone2: string;
    phone3: string;
    fax: string;
    fax2: string;
    website: string;
    description: string;
    isactive: number;
    dateadded: string;
    newexhibitor: string;
    twitter: string;
    linkedin: string;
    facebook: string;
    instagram: string;
    logo: string;
    approvestatus: string;
    booths: ExhibitorBooth[];
    contacts: ExhibitorContact[];
    productcategories: unknown[];
};

type ExhibitorBooth = {
    hallid: string;
    dimensions: string;
    boothnumber: string;
    pavilionid: string;
    boothtype: string;
    hall: string;
    squareft: number;
    pavilion: string;
    boothtypedisplay: string;
    boothtags: string;
};

type ExhibitorContact = {
    zip: string;
    lname: string;
    phone: string;
    state: string;
    email: string;
    fname: string;
    city: string;
    country: string;
    title: string;
    phone2: string;
    address1: string;
    fax: string;
    fullname: string;
    address3: string;
    address2: string;
};
